module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/80/assets/images/8e9a43608c38b92a216e09f3316d7d1b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_info.svg
// module id = 9wCb
// module chunks = 0